/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert': {
    width: 16,
    height: 16,
    viewBox: '0 0 48.4 55.43',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M43.81 28.88V20.4a.78.78 0 0 0 0-.15.84.84 0 0 0 0-.15 19.61 19.61 0 0 0-39.21 0 .78.78 0 0 0 0 .15.84.84 0 0 0 0 .15v15.9l-4 8.6a.88.88 0 0 0 .79 1.25H47a.88.88 0 0 0 .74-.41.86.86 0 0 0 .06-.84l-4-8.6M16.52 49.37c0 3.07 3.44 5.56 7.68 5.56s7.68-2.44 7.68-5.56"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/alert.js